import React from 'react';
import { Form } from 'react-bootstrap';

import { useTranslation } from '../../../common/hooks/useTranslation';
import QuillTextEditor from '../../../app/components/QuillTextEditor';
import FormRow from '../../../app/components/FormRow';
import { CreateUpdateSurveyEmailContentDto } from '../../../common/pokCore/autogenerated/pokApiClient';

interface EmailFormFieldsProps {
  emailData: CreateUpdateSurveyEmailContentDto;
  propertyChange: (obj: Partial<CreateUpdateSurveyEmailContentDto>) => void;
  readOnly?: boolean;
}

export const EmailFormFields: React.FC<EmailFormFieldsProps> = ({
  emailData,
  propertyChange,
  readOnly,
}) => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <Form className="d-grid gap-4 mb-3">
      <FormRow controlId="subjectPl" label={t(tk.survey.emailSubject)}>
        <Form.Control
          type="text"
          value={emailData?.emailSubject || ''}
          onChange={e => propertyChange({ emailSubject: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>

      <FormRow controlId="templatePl" label={t(tk.survey.emailTemplate)}>
        <QuillTextEditor
          value={emailData?.emailBody || ''}
          onChange={val => propertyChange({ emailBody: val || '' })}
          readOnly={readOnly}
          uniqueKey="emailBodyPl"
        />
      </FormRow>

      <FormRow controlId="subjectEn" label={t(tk.survey.emailSubjectEn)}>
        <Form.Control
          type="text"
          value={emailData?.emailSubjectEn || ''}
          onChange={e => propertyChange({ emailSubjectEn: e.target.value })}
          disabled={readOnly}
        />
      </FormRow>

      <FormRow controlId="templateEn" label={t(tk.survey.emailTemplateEn)}>
        <QuillTextEditor
          value={emailData?.emailBodyEn || ''}
          onChange={val => propertyChange({ emailBodyEn: val || '' })}
          readOnly={readOnly}
          uniqueKey="emailBodyEn"
        />
      </FormRow>
    </Form>
  );
};
